<template>
<div>
  <v-autocomplete
    ref="autocomplete"
    auto-select-first
    clearable
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    @blur="emitBlur"
    :solo="solo"
    small-chips
    multiple
    v-bind="resetProps"
  />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    value: [String, Array],
    solo: Boolean,
    dense: Boolean,
    filterWord: String,
  },
  data() {
    return {
      innerValue: this.value,
    };
  },

  async created() {
    await this.getAll();
  },

  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  methods: {
    ...mapActions("category", ["getAll"]),

    emitBlur() {
      this.$emit("blur");
    },

    getName(cat) {
      let f = this.$store.getters["category/getAll"].filter(
        (category) => category.id === cat.categoryId
      );
      return f.length === 1 ? f[0].name : "";
    },
    filterItems(value) {
      return value.indexOf(this.filterWord) !== 0;
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),

    resetProps() {
      return { ...this.$attrs };
    },

    categoryItems() {
      return this.$store.getters["category/getAll"]
        .filter((category) => !category.categoryId)
        .filter((category) => {
          if (this.filterWord) {
            return category.type === this.filterWord;
          } else {
            return true;
          }
        })
        .map((item) => {
          return {
            ...item,
            active: true,
          };
        });
    },

    tagItems() {
      return this.$store.getters["category/getAll"]
        .filter((category) => category.categoryId)
        .filter((category) => {
          if (this.filterWord) {
            return category.type === this.filterWord;
          } else {
            return true;
          }
        });
    },

    dataItems() {
      return this.categoryItems.map((item) => {
        let children = this.tagItems.filter((tag) => tag.categoryId == item.id);
        return {
          ...item,
          children: children,
        };
      });
    },

    options() {
      let categoryItems = this.categoryItems.map((category) => {
        return {
          value: category.id,
          text: category.name,
        };
      });

      let tagItems = this.tagItems.map((category) => {
        return {
          value: category.id,
          text: this.getName(category) + " > " + category.name,
        };
      });

      return [].concat(categoryItems, tagItems).sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });
    },
  },
};
</script>